module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-lista-reboques-map",
    class: {
      'open': _vm.opened
    }
  }, [_c('div', {
    staticClass: "c-a-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Digite o nome ou ID para filtrar"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.filteredReboquistas), function(reboquista) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.focarReboquista(reboquista)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "flex": "1"
      }
    }, [_c('i', {
      staticClass: "fa fa-user-circle fa-3x",
      class: {
        'text-info': !_vm.possuiGrvsPendentes(reboquista), 'text-danger': _vm.possuiGrvsPendentes(reboquista)
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "flex": "3"
      }
    }, [_c('strong', [_vm._v("\n            " + _vm._s(reboquista.nome) + "\n            "), _c('br'), _vm._v("\n            (ID: " + _vm._s(reboquista.id) + ")\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(reboquista.grvs.length) + " " + _vm._s(reboquista.grvs.length === 1 ? 'GRV pendente' : 'GRVs pendentes'))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cb1bd96","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/callcenter/components/btn-lista-reboques-map/ListaReboquesMap.vue
// module id = 1596
// module chunks = 17